<script>
  export let set
  export let seti
  export let exercises
  export let disableSetReordering = false
  export let disableExerciseReordering = false
  export let reorderHandleMouseDown = () => {}

  import { tick, createEventDispatcher } from 'svelte'
  import { dndzone } from 'svelte-dnd-action'

  import WorkoutPlanSetExerciseEditWidget from './WorkoutPlanSetExerciseEditWidget.svelte'
  import WorkoutPlanSetExerciseNewWidget from './WorkoutPlanSetExerciseNewWidget.svelte'
  import { tooltipable } from './tooltipable.js'

  const dispatch = createEventDispatcher()

  function saveNewExercise(event) {
    event.detail.set = set
    dispatch('saveNewExercise', event.detail)
    addNew = false
  }

  function handleDeleteSet() {
    dispatch('deleteSet', set)
  }

  let dragDisabled = true

  function handleDndConsider(e) {
    set.exercises = e.detail.items
  }
  function handleDndFinalize(e) {
    set.exercises = e.detail.items
    dragDisabled = true
    dispatch('reorderExercises', set)
  }

  function startDrag(e) {
    // preventing default to prevent lag on touch devices (because of the browser checking for screen scrolling)
    e.preventDefault()
    dragDisabled = false
  }

  let addNew = false
  let addNewElement

  async function addClick() {
    addNew = true
    await tick()
    addNewElement.scrollIntoView(false)
  }
</script>

<div class="card">
  <div class="card-header d-flex align-items-center">
    <span class="me-auto">Set {seti + 1}</span>
    <div class="btn-group" role="group">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm"
        use:tooltipable
        title="Drag to Reorder Sets in Plan"
        disabled={disableSetReordering}
        on:mousedown={reorderHandleMouseDown}
        on:touchstart={reorderHandleMouseDown}
        ><i class="bi bi-arrows-expand" /></button
      >
      <button
        class="btn btn-outline-primary btn-sm"
        disabled={addNew}
        use:tooltipable
        title="Add new Exercise to Set"
        on:click={addClick}><i class="bi bi-plus-square" /></button
      >
      <button
        class="btn btn-outline-danger btn-sm"
        use:tooltipable
        title="Delete Set"
        on:click={handleDeleteSet}><i class="bi bi-trash" /></button
      >
    </div>
  </div>
  <ul
    class="list-group list-group-flush"
    use:dndzone={{
      items: set.exercises,
      type: 'set' + set.id,
      dragDisabled: dragDisabled,
      dropTargetStyle: { outline: 'var(--bs-primary) solid 2px' },
    }}
    on:consider={handleDndConsider}
    on:finalize={handleDndFinalize}
  >
    {#each set.exercises as exercise (exercise.id)}
      <WorkoutPlanSetExerciseEditWidget
        {exercise}
        disableReordering={disableExerciseReordering}
        reorderHandleMouseDown={startDrag}
        on:saveExercise
        on:deleteExercise
      />
    {/each}
  </ul>
  {#if addNew}
    <ul class="list-group list-group-flush" bind:this={addNewElement}>
      <WorkoutPlanSetExerciseNewWidget
        {exercises}
        on:saveExercise={saveNewExercise}
        on:abortEdit={() => {
          addNew = false
        }}
      />
    </ul>
  {/if}
</div>
